<template>
  <div>
    <el-collapse accordion style="margin-bottom: 20px">
      <el-collapse-item title="取得元検索条件" name="1">
        <!-- 查询条件 -->
        <el-form
          :model="searchForm"
          label-width="auto"
          style="max-width: 100%; position: relative"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="区分">
                <el-select v-model="kbn" placeholder="選択">
                  <el-option label="中古車" value="0"></el-option>
                  <el-option label="中古パーツ" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 20px">
              <el-form-item label="管理番号">
                <el-input
                  v-model="searchForm.management_number"
                  placeholder="入力"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="メーカー">
                <el-select
                  v-model="searchForm.manufacturer"
                  placeholder="選択"
                  @change="fetchCarTypes"
                >
                  <el-option
                    v-for="item in manufacturers"
                    :key="item.code"
                    :label="item.name_ja"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="車種">
                <el-select v-model="searchForm.type" placeholder="選択">
                  <el-option
                    v-for="item in carTypes2"
                    :key="item.code"
                    :label="item.name_ja"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item style="position: absolute; bottom: 0px; right: 10px">
            <el-button type="primary" @click="fetchInfos">検索</el-button>
            <el-button @click="resetSearch">リセット</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <el-row justify="end">
      <el-button type="success" @click="saveUp">保存</el-button>
    </el-row>
    <div class="container">
      <!-- 左侧表格 -->
      <div class="table-box">
        <h3>販売一覧</h3>
        <draggable
          :list="leftInfos"
          group="items"
          item-key="id"
          class="drag-container"
        >
          <template #item="{ element }">
            <el-card class="table-item">
              <el-row>
                <el-col :span="4">
                  <el-avatar shape="square" size="large" :src="element.url" />
                </el-col>
                <el-col :span="18" style="padding-left: 5px">
                  <el-form-item label="管理番号：" style="font-size: 13px">
                    {{ element.id }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </template>
        </draggable>
      </div>

      <!-- 右侧表格 -->
      <div class="table-box">
        <h3>取得元</h3>
        <draggable
          :list="infos"
          group="items"
          item-key="id"
          class="drag-container"
        >
          <template #item="{ element }">
            <el-card class="table-item">
              <el-row>
                <el-col :span="4">
                  <el-avatar shape="square" size="large" :src="element.url" />
                </el-col>
                <el-col :span="18" style="padding-left: 5px">
                  <el-form-item label="管理番号：" style="font-size: 13px">
                    {{ element.id }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </template>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import {
  ElMessage,
  ElLoading,
} from "element-plus";
import { supabase } from "@/supabase.js"; // Supabase 连接
import draggable from "vuedraggable";
export default {
  components: {
    draggable, // 注册组件
  },
  setup() {
    const infos = ref([]);
    const leftInfos = ref([]);
    const kbn = ref("0");
    //  查询条件
    const searchForm = ref({
      management_number: "", // 管理番号
      manufacturer: "", // メーカー
      type: "", // 車種
    });
    const manufacturers = ref([]); // 车辆制造商
    const carTypes = ref([]); // 车辆种类
    const carTypes2 = ref([]); // 车辆种类

    // 获取列表
    const fetchInfos = async () => {
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let table = "car_info";
      if (kbn.value === "1") {
        table = "part_info";
      }

      let query = supabase.from(table).select("*");

      if (searchForm.value.management_number) {
        query = query.ilike(
          "management_number",
          `%${searchForm.value.management_number}%`
        );
      }
      if (searchForm.value.manufacturer) {
        query = query.eq("manufacturer", searchForm.value.manufacturer);
      }
      if (searchForm.value.type) {
        query = query.eq("type", searchForm.value.type);
      }

      const { data, error } = await query;

      if (error) {
        // 关闭 loading 动画
        loading.close();
        console.error("データ取得エラー:", error);
      } else {
        // 关闭 loading 动画
        loading.close();
        infos.value = (data || []).map((item) => ({
          url: item.img, // 绑定URL
          id:
            kbn.value === "1"
              ? item.management_number + "_パーツ"
              : item.management_number + "_車",
        }));
      }
    };

    // 获取左侧数据
    const fetchLeftInfos = async () => {
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const { data, error } = await supabase
        .from("img_info")
        .select("sub_imgurl,sub_id,kbn")
        .eq("kbn", "2");

      console.log("left:" + data);
      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        leftInfos.value = (data || []).map((item) => ({
          url: item.sub_imgurl, // 绑定URL
          id: item.sub_id,
        }));
      }
      loading.close();
    };

    // 📌 获取制造商 & 车型数据
    const fetchOptions = async () => {
      const { data: manufacturersData } = await supabase
        .from("manufacturer_m")
        .select("code, name_ja");
      const { data: carTypesData } = await supabase
        .from("model_m")
        .select("code, name_ja");
      manufacturers.value = manufacturersData || [];
      carTypes.value = carTypesData || [];
    };
    const fetchCarTypes = async () => {
      if (!searchForm.value.manufacturer) return;
      const { data } = await supabase
        .from("model_m")
        .select("code, name_ja")
        .eq("m_code", searchForm.value.manufacturer);
      carTypes2.value = data || [];
    };

    // resetSearch
    const resetSearch = () => {
      searchForm.value = {
        management_number: "",
        manufacturer: "",
        type: "",
      };
    };

    const getManufacturerName = (code) => {
      const manufacturer = manufacturers.value.find((m) => m.code == code);
      return manufacturer ? manufacturer.name_ja : "-"; // 如果找不到就返回 "-"
    };

    const getCarTypeName = (code) => {
      const carType = carTypes.value.find((t) => t.code == code);
      return carType ? carType.name_ja : "-"; // 如果找不到就返回 "-"
    };

    const saveUp = async () => {
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let setDatas = [];
      setDatas = leftInfos.value.map((item) => ({
        kbn: "2",
        sub_id: item.id,
        sub_imgurl: item.url,
      }));

       // 删除数据库记录
       await supabase.from("img_info").delete().eq("kbn", "2");
       const { error } = await supabase.from("img_info").insert(setDatas);
       if (error) {
        console.error("データ保存エラー:", error);
        ElMessage.error("保存に失敗しました。");
      } else {
        ElMessage.success("データを保存しました。");
      }
      // 关闭 loading 动画
      loading.close();
    };

    onMounted(async () => {
      await fetchOptions();
      await fetchLeftInfos();
    });

    return {
      kbn,
      infos,
      leftInfos,
      searchForm,
      fetchInfos,
      resetSearch,
      manufacturers,
      carTypes,
      getManufacturerName,
      getCarTypeName,
      fetchCarTypes,
      carTypes2,
      saveUp
    };
  },
};
</script>
<style scoped>
.el-divider >>> .el-divider__text {
  background-color: #f5f5f5 !important;
  color: var(--el-text-color-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  position: absolute;
}
.ellipsis-text {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制最多显示2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap; /* 保留换行 */
  word-break: break-word;
  max-height: 3.2em; /* 适应2行 */
  line-height: 1.6em;
}
.el-collapse {
  --el-collapse-border-color: var(--el-border-color-lighter);
  --el-collapse-header-height: 48px;
  --el-collapse-header-bg-color: none;
  --el-collapse-header-text-color: var(--el-text-color-primary);
  --el-collapse-header-font-size: 13px;
  --el-collapse-content-bg-color: none;
  --el-collapse-content-font-size: 13px;
  --el-collapse-content-text-color: var(--el-text-color-primary);
  border-bottom: 1px var(--el-border-color) var(--el-border-style);
  border-top: 1px var(--el-border-color) var(--el-border-style);
}
.container {
  display: flex;
  justify-content: space-around;
  margin: 20px;
}
.table-box {
  width: 40%;
  border: 1px solid #ddd;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 5px;
}
.drag-container {
  min-height: 150px;
  padding: 10px;
  border: 1px dashed #ccc;
  background: white;
}
.table-item {
  padding: 10px;
  margin-bottom: 10px;
  cursor: grab;
}
.delete-btn {
  text-align: right;
}
.el-card__body {
  padding: 0px;
}
</style>
